var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm._f("lang")('draw_is_running')))]),_vm._v(" "),(_vm.indefinite)?_c('b-progress',{attrs:{"value":100,"max":100,"variant":"success","animated":""}}):_c('b-progress',{attrs:{"value":_vm.passed,"max":_vm.estimated,"variant":"success"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }